import { Toaster } from 'react-hot-toast';

interface CustomToastProps {
  dark?: boolean;
}

export default function CustomToast({ dark }: CustomToastProps) {
  return (
    <Toaster
      position="top-center"
      gutter={8}
      containerStyle={{
        zIndex: 99999,
        top: 20,
        right: 20,
      }}
      toastOptions={{
        duration: 4000,
        style: {
          background: dark ? '#1a1a1a' : '#ffffff',
          border: dark
            ? '1px solid rgba(255, 255, 255, 0.1)'
            : '1px solid #e5e5e5',
          borderRadius: '12px',
          color: dark ? '#ffffff' : '#1a1a1a',
          fontSize: '14px',
          fontWeight: '500',
          padding: '12px 16px',
          boxShadow: dark
            ? '0 8px 32px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.2)'
            : '0 2px 8px rgba(0, 0, 0, 0.08)',
          maxWidth: '350px',
          minHeight: '48px',
          display: 'flex',
          alignItems: 'center',
        },
        success: {
          style: {
            background: dark ? '#1d4e20' : '#e8f5e9',
            border: dark ? '1px solid #34c759' : '1px solid #a5d6a7',
            color: dark ? '#ffffff' : '#1d4e20',
          },
          iconTheme: {
            primary: '#34c759',
            secondary: dark ? '#1a1a1a' : '#ffffff',
          },
        },
        error: {
          style: {
            background: dark ? '#4a1a1a' : '#ffebee',
            border: dark ? '1px solid #ff3b30' : '1px solid #ef9a9a',
            color: dark ? '#ff3b30' : '#d70015',
          },
          iconTheme: {
            primary: '#ff3b30',
            secondary: dark ? '#1a1a1a' : '#ffffff',
          },
        },
        loading: {
          style: {
            background: dark ? '#1a2a4a' : '#e3f2fd',
            border: dark ? '1px solid #007aff' : '1px solid #90caf9',
            color: dark ? '#007aff' : '#0056b3',
          },
          iconTheme: {
            primary: '#007aff',
            secondary: dark ? '#1a1a1a' : '#ffffff',
          },
        },
      }}
    />
  );
}
